module.exports = __webpack_public_path__ + "img/4.d68bd683.png";